import { IAutoMapper } from "../interfaces";

export const mapNlpKeywordModel = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "NlpKeywordModel")
    .forMember("keywordGroupType", o => o.keywordGroupType)
    .forMember("keywordGroupID", o => o.keywordGroupId)
    .forMember("keywordID", o => o.keywordId)
    .forMember("keywordName", o => o.keywordName)
    .forMember("keywordParsingFormula", o => o.keywordParsingFormula)
    .forMember("keywordType", o => o.keywordType)
    .forMember("lowestValue", o => o.lowestValue)
    .forMember("highestValue", o => o.highestValue);

};
